// Scrolls to the top of the page on every route change.
// Mounted once inside <BrowserRouter> so it has access to useLocation().
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Use rAF so the new page's first paint already lands at top.
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
            // Also reset any internally-scrolled main containers (e.g. .app-shell)
            const shell = document.querySelector(".app-shell");
            if (shell && typeof shell.scrollTo === "function") {
                try { shell.scrollTo({ top: 0, left: 0 }); } catch { /* ignore */ }
            }
        });
    }, [pathname]);
    return null;
}
